/**
 *
 * @author arman
 * @since 1/12/18
 *
 */

import React from 'react';
import utils from '../../utility/utils';
import BoxHeader from '../shared/box-header.component';

const styles = {
  root: {

  },
  table: {
    width: '100%'
  },
  th: {
    fontSize: '15px',
    textAlign: 'left',
  },
  tr: {

  },
  td: {
    paddingTop: '10px',
    paddingBottom: '10px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd'
  },
};

const ReviewListView = ({reviews, className, style}) => (
  <div className={className} style={{...styles.root, ...style.root}}>
    <BoxHeader title='Review(s)' style={style.header} />
    <div style={style.box}>
      <table style={styles.table}>
        <tbody>
        <tr style={styles.th}>
          <th>Reviewed at</th>
          <th>Reviewed by</th>
          <th width='50%' style={{textAlign: 'center'}}>Review</th>
        </tr>
        {
          reviews
            .sort((reviewA, reviewB) => Date.parse(reviewB.created_at) - Date.parse(reviewA.created_at))
            .map((review, index) => (
              <tr key={index} style={styles.tr}>
                <td style={styles.td}>{utils.toAppDate(review.created_at)}</td>
                <td style={styles.td}>{review.reviewed_by.name}</td>
                <td style={{...styles.td, ...{textAlign: 'center'}}}>{review.comment}</td>
              </tr>
            ))
        }
        </tbody>
      </table>
    </div>
  </div>
);

export default ReviewListView;


// WEBPACK FOOTER //
// ./src/screens/mission-view/review-list-view.component.js